import { ExternalLink } from 'lucide-react';
import { FileDropzone } from '../components/FileDropzone';
import { ImportProgress } from '../components/ImportProgress';
import { PrivacyNotice } from '../components/PrivacyNotice';
import type { AnalysisResult, AnalysisWarning } from '../domain/models';
import type { ImportProgress as ImportProgressState } from '../workers/parserClient';

type HomePageProps = {
  disabled: boolean;
  progress?: ImportProgressState;
  result?: AnalysisResult | null;
  error?: string | null;
  warnings?: AnalysisWarning[];
  onFile: (file: File) => void;
  onSample: (kind: 'day' | 'trip' | 'noise' | 'unknown') => void;
};

export function HomePage({ disabled, progress, result, error, warnings, onFile, onSample }: HomePageProps) {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Timeline Local Studio</h1>
          <p className="page-subtitle">Google Maps Timeline のエクスポートデータを、ローカルのブラウザ上で可視化・集計します。</p>
        </div>
      </header>

      <PrivacyNotice />
      <FileDropzone disabled={disabled} onFile={onFile} onSample={onSample} />
      <ImportProgress progress={progress} result={result} error={error} warnings={warnings} />

      <section className="surface" style={{ padding: 18 }}>
        <div className="section">
          <div>
            <h2 className="section-title">Export Guide</h2>
            <p className="section-note">iOS / Android の Google Maps アプリから Timeline data export を実行し、生成された JSON を選択します。</p>
          </div>
          <div className="button-row">
            <a className="button" href="https://support.google.com/maps/answer/6258979?co=GENIE.Platform%3DiOS&hl=ja" target="_blank" rel="noreferrer">
              <ExternalLink size={16} aria-hidden="true" />
              iOS
            </a>
            <a className="button" href="https://support.google.com/maps/answer/6258979?co=GENIE.Platform%3DAndroid&hl=ja" target="_blank" rel="noreferrer">
              <ExternalLink size={16} aria-hidden="true" />
              Android
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
